import {
  NavBar,
  Hero,
  About,
  Projects,
  SocialLinks,
  Experience,
  Contact,
} from "./constants/components.js";

const App = () => {
  return (
    <div className="bg-gray-800">
      <NavBar />
      <Hero />
      <About />
      <Projects />
      <Experience />
      <Contact />
      <SocialLinks />
    </div>
  );
};

export default App;
